import React from 'react';

export const analyzeButtonDelay = 5;
export const DefaultConfigOptionEnum = {
  Blank: -2,
  New: -1,
};

export const ColumnTypeEnum = {
  LastName: 'LastName',
  FirstName: 'FirstName',
  StudentBirthDate: 'StudentBirthDate',
  StudentNumber: 'StudentNumber',
  ParentFirstName: 'ParentFirstName',
  ParentLastName: 'ParentLastName',
  ParentEmail: 'ParentEmail',
  ParentPhone: 'ParentPhone',
  Address1: 'Address1',
  Address2: 'Address2',
  City: 'City',
  State: 'State',
  Zip: 'ZipCode',
  SSN: 'SSN',
  CaseType: 'CaseType',
  CaseNumber: 'StudentCaseNumber',
  StateNumber: 'StateNumber',
};

export const HeaderOptions = [
  { value: -1, key: 'skip', text: <span className={'skip-text'}>Skip</span> },
  { value: ColumnTypeEnum.LastName, key: 0, text: 'Last Name' },
  { value: ColumnTypeEnum.FirstName, key: 1, text: 'First Name' },
  { value: ColumnTypeEnum.StudentBirthDate, key: 2, text: 'DOB (YYYYMMDD)' },
  { value: ColumnTypeEnum.StudentNumber, key: 3, text: 'Student Number' },
  { value: ColumnTypeEnum.ParentFirstName, key: 8, text: 'Parent First Name' },
  { value: ColumnTypeEnum.ParentLastName, key: 9, text: 'Parent Last Name' },
  { value: ColumnTypeEnum.ParentEmail, key: 10, text: 'Parent Email' },
  { value: ColumnTypeEnum.ParentPhone, key: 11, text: 'Parent Phone' },
  { value: ColumnTypeEnum.Address1, key: 12, text: 'Address 1' },
  { value: ColumnTypeEnum.Address2, key: 13, text: 'Address 2' },
  { value: ColumnTypeEnum.City, key: 14, text: 'City' },
  { value: ColumnTypeEnum.State, key: 15, text: 'State' },
  { value: ColumnTypeEnum.Zip, key: 16, text: 'Zip Code' },
  { value: ColumnTypeEnum.SSN, key: 17, text: 'SSN' },
  { value: ColumnTypeEnum.CaseType, key: 23, text: 'Case Type' },
  { value: ColumnTypeEnum.CaseNumber, key: 24, text: 'Case Number' },
  { value: ColumnTypeEnum.StateNumber, key: 25, text: 'State Number' },
];

export const DelimOptions = [
  { label: 'Comma', value: ',' },
  { label: 'Tab', value: decodeURIComponent('\t') },
  { label: 'Pipe', value: '|' },
];

export const MatchTypeEnum = {
  StudentNumber: 0,
  SSN: 1,
  StateNumber: 2,
};
export const MatchOptions = [
  { label: 'Student Number', value: MatchTypeEnum.StudentNumber },
  { label: 'SSN', value: MatchTypeEnum.SSN },
  { label: 'State Number', value: MatchTypeEnum.StateNumber },
];

export const CaseTypeOptions = [
  { value: true, label: 'Use Case Type Mapping ' },
  { value: false, label: 'Default to Case Type' },
];

export const IgnoreStateNumberLeadingZerosOptions = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
];

export const ImportTypeEnum = {
  None: 0,
  Direct_Certified: 7,
  Direct_Certified_Foster: 8,
  Direct_Certified_KinGAP: 9,
  Homeless: 10,
  Migrant: 11,
  Runaway: 12,
  Headstart: 13,
};
export const DCImportTypes = [
  ImportTypeEnum.Direct_Certified,
  ImportTypeEnum.Direct_Certified_Foster,
  ImportTypeEnum.Direct_Certified_KinGAP,
  ImportTypeEnum.Homeless,
  ImportTypeEnum.Migrant,
  ImportTypeEnum.Runaway,
  ImportTypeEnum.Headstart,
];



// WEBPACK FOOTER //
// ./src/pages/dcimport/helpers/Constants.js